'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientIp = void 0;
const request_1 = require("./request");
/**
 * Retrieve the client IP address for the given `request`.
 *
 * @param {Object} request
 *
 * @returns {String}
 */
function getClientIp(request) {
    return new request_1.Request(request).getClientIp();
}
exports.getClientIp = getClientIp;
